export enum UserFormMode {
  Edit = 'edit',
  Add = 'add',
}
